import { render, staticRenderFns } from "./InnerLoader.vue?vue&type=template&id=67ab779c&"
import script from "./InnerLoader.vue?vue&type=script&lang=ts&"
export * from "./InnerLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports